module.exports = __webpack_public_path__ + "img/portfolio-04-670x479.3a4fbd3f.jpg";